import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "即时设计",
  "alternateName": "JS Design",
  "url": "https://js.design",
  "logo": "https://img.js.design/assets/webImg/favicon.ico",
  "sameAs": [
    "https://weibo.com/u/7627805985",
    "https://www.xiaohongshu.com/user/profile/61278b1b000000000101f5a2?xsec_token=AB07Oa0SVd225S0uI1XGf92UgMKtA9dNCOUS_iqDLn9oM%3D&xsec_source=pc_search",
    "https://www.zhihu.com/org/ji-shi-she-ji-60",
  ],
  "description": "即时设计是一款专业的 UI 设计工具，支持多人实时协作与在线编辑，为团队提供从设计到交付的一体化解决方案。",
  "foundingDate": "2020",
  "founder": {
    "@type": "Person",
    "name": "即时设计团队"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "email": "contact@js.design",
    "telephone": "010-57296155",
    "availableLanguage": ["Chinese", "English"]
  }
}

const SOFTWARE_APPLICATION_DATE_MODIFIED = "2026-2-28"

const softwareApplicationJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "即时设计",
  "applicationCategory": ["DesignApplication", "WebApplication", "CollaborationApplication"],
  "applicationSubCategory": ["UI设计软件", "原型设计工具", "团队协作平台"],
  "operatingSystem": "Windows, macOS, Linux, Web Browser",
  "description": "即时设计（Js.Design）是Figma 的国产替代方案，一款支持在线 UI 设计、原型制作与团队协作的专业工具",
  "url": "https://js.design/",
  "featureList": [
    "多人在线实时协作设计",
    "精细化矢量图形编辑",
    "交互原型与动效设计",
    "自动设计标注与切图",
    "团队组件库与设计规范",
    "云端资源管理与共享",
    "Figma/Sketch/XD文件导入",
    "设计稿一键发布为网页",
    "AI辅助设计与素材生成",
    "插件生态系统支持"
  ],
  "fileFormat": ["jsd", "sketch", "figma", "adobe-xd", "axure", "svg", "png", "jpg", "pdf", "gif", "webp"],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "CNY"
  },
  "dateModified": SOFTWARE_APPLICATION_DATE_MODIFIED
}

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "即时设计",
  "alternateName": ["即时设计官网", "JS Design"],
  "url": "https://js.design/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://js.design/community?category=search&search={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
}

const IGNORE_CONANICAL_LIST = ['/login', '/user'];

function SEOInfo() {
  const location = useLocation();
  const baseUrl = 'https://js.design';
  let canonicalUrl = `${baseUrl}${location.pathname}`;
  const isHome = ['/', '/home'].includes(location.pathname);
  const showJSONLD = isHome;

  // 针对特定路径特殊处理 canonical 链接
  let showConanical = !IGNORE_CONANICAL_LIST.includes(location.pathname);

  if (location.pathname === '/community') {
    const searchParams = new URLSearchParams(location.search);
    const category = searchParams.get('category');
    switch (category)  {
      case 'search': {
        canonicalUrl = `${baseUrl}`;
        break;
      }
      case 'personHome': {
        showConanical = false;
        break;
      }
      case 'explore': {
        canonicalUrl = `${location.pathname}?category=explore`;
        break;
      }
      case 'plugin': {
        canonicalUrl = `${location.pathname}/?category=plugin`;
        break;
      }
    }
  }

  return (
    <Helmet>
      {
        showConanical && <link rel="canonical" href={canonicalUrl} />
      }
      {
        showConanical && <link rel="alternate" href={canonicalUrl} hrefLang="zh-CN" />
      }
      {showJSONLD && [
        <script key="ldjson-organization" type="application/ld+json" data-react-helmet="true">
          {JSON.stringify(jsonLd)}
        </script>,
        <script key="ldjson-software" type="application/ld+json" data-react-helmet="true">
          {JSON.stringify(softwareApplicationJsonLd)}
        </script>,
        <script key="ldjson-website" type="application/ld+json" data-react-helmet="true">
          {JSON.stringify(websiteJsonLd)}
        </script>,
      ]}
    </Helmet>
  );
}

export default SEOInfo;
